module.exports = __webpack_public_path__ + "assets/img/PINNACLE.af325529.png";